<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
      single-expand
      :expanded.sync="expanded"
      item-key="zug_id"
    >
      <template #[`item.pra_busena`]="{ item }">
        <el-prasymas-busena :busena="item.pra_busena_pavadinimas" />
      </template>
      <template #[`item.busenu_istorija`]="{ item }">
        <el-switch
          class="mt-0 mb-2"
          v-if="item.canBusenuIstorija"
          v-model="item.expandedBusena"
          @click.native="changeExpandedBusena(item)"
        />
      </template>
      <template #[`item.dokumentai`]="{ item }">
        <div class="nowrap">
          <el-byla
            v-for="byla in item.bylos"
            :key="byla.byl_id"
            :byla="byla"
            color="primary"
            :with-name="byla.withName"
            in-line
            :class="byla.class"
          />
          <el-byla
            v-for="byla in item.bylos_preview"
            :key="byla.byl_id"
            :byla="byla"
            color="primary"
            :with-name="byla.withName"
            in-line
            :class="byla.class"
          />
        </div>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="informacija-expanded pb-0">
          <prasymas-istorija-busena
            v-if="item.expandedBusena"
            :pra-id="item.pra_id"
            minimal
            :key="`busena-${item.pra_id}`"
          />
        </td>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '@/mixins/math'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import PrasymasIstorijaBusena from './PrasymasIstorijaBusena'

export default {
  name: 'PrasymasInformacija',
  components: {
    PrasymasIstorijaBusena,
  },
  mixins: [userRole, busena, math],
  props: {
    readonlyForm: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    refreshKey: String,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      informacija: [],
      expanded: [],
      itemsPerPageOptions: [5, 10, 50, -1],
      pageSize: 5,
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'prasymasTipas', 'appSavitarna']),
    headers() {
      return [
        {
          text: 'Registracijos numeris',
          align: 'start',
          value: 'pra_numeris',
        },
        {
          text: 'Perdavimo data',
          align: 'center',
          value: 'pra_perdavimo_data',
        },
        {
          text: 'Duomenų teikėjas',
          align: 'start',
          value: 'pra_teikejas',
        },
        {
          text: 'Būsena',
          align: 'center',
          value: 'pra_busena',
        },
        {
          text: 'Būsenos data',
          align: 'center',
          value: 'pra_busenos_data',
        },
        {
          text: 'Dokumentai',
          align: 'start',
          sortable: false,
          value: 'dokumentai',
        },
        {
          text: 'Veiksmų istorija',
          align: 'start',
          value: 'busenu_istorija',
          width: 100,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.informacija.map(item => {
        item.canBusenuIstorija = true

        item.bylos = item.bylos.map(byla => {
          return {
            ...byla,
            byl_tipas: byla.byl_sugeneruota ? 'ntr_pra_gen' : 'ntr_pra_rink',
            byl_url: `ntrpaslaugos/byla/${byla.byl_id}/${byla.byl_hash}/content`,
          }
        })

        item.bylos_preview = []
        if (
          item.pra_busena === 'rengiamas' ||
          item.pra_busena === 'grazintas'
        ) {
          item.bylos_preview.push({
            byl_id: `${item.pra_id}-prasymas`,
            byl_sugeneruota: true,
            byl_rusis: 'Prašymas (peržiūra)',
            byl_pavadinimas: 'Prašymas (peržiūra)',
            byl_tipas: 'preview_ntr',
            byl_url: `ntrpaslaugos/prasymas/${item.pra_id}/perziura`,
          })
          item.bylos_preview.push({
            byl_id: `${item.pra_id}-pranesimas`,
            byl_sugeneruota: true,
            byl_rusis: 'Pranešimas registrui (peržiūra)',
            byl_pavadinimas: 'Pranešimas registrui (peržiūra)',
            byl_tipas: 'preview_pran',
            byl_url: `ntrpaslaugos/prasymas/${item.pra_id}/perziura/pranesimas`,
          })
        }

        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 5
    },
    showDuomenuIstorija() {
      return this.roleRG
    },
    isSavitarna() {
      return this.appSavitarna
    },
  },
  watch: {
    refreshKey() {
      this.getData(true)
    },
  },
  beforeCreate() {
    this.$root.$off('reloadPrasymasInformacija')
  },
  created() {
    this.$root.$on('reloadPrasymasInformacija', () => {
      this.getData()
    })
    this.getData()
  },
  methods: {
    getData(silent = false) {
      if (!silent) {
        this.pageloading = true
        this.loading = true
      }
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/informacija`)
        .then(res => {
          this.informacija = res.data.informacija
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    clearExpanded(item) {
      this.informacija.forEach(e => {
        if (e.pra_id != item.pra_id) {
          e.expandedBusena = false
        }
      })
    },
    changeExpandedBusena(item) {
      this.clearExpanded(item)

      if (item.expandedBusena) {
        this.expanded = [item]
      } else {
        this.expanded = []
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.bylaWithName {
  display: block;
}
.informacija-expanded {
  box-shadow: none;
  background: rgb(248, 248, 248);
}
</style>
